<template>
  <div>
    <v-btn color="primary" v-on:click="eventDialog = true;editing = false;">Create</v-btn>
    <div class="calendar-container">
      <calendar-view :events="events" :showDate="showDate" :time-format-options="{hour: 'numeric', minute:'2-digit'}"
        :show-event-times="showEventTimes" :class="themeClasses" @click-date="onClickDay" @click-event="onClickEvent">
        <calendar-view-header slot="header" slot-scope="{ headerProps }" :header-props="headerProps"
          @input="setShowDate" />
      </calendar-view>
    </div>

    <v-dialog v-model="eventDialog" max-width="50%">
      <v-card>
        <v-card-title>
          <h3 v-if="!editing">Create Event</h3>
          <h3 v-else>Edit Event</h3>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-layout column>
              <v-flex>
                <v-text-field v-if="!editing" v-model="eventTitle" label="Title" required></v-text-field>
                <v-text-field v-else v-model="specificEvent.title" label="Title" required></v-text-field>
              </v-flex>
              <v-flex>
                <v-textarea v-if="!editing" v-model="eventDescription" label="Description" required></v-textarea>
                <v-textarea v-else v-model="specificEvent.description" label="Description" required></v-textarea>
              </v-flex>
              <v-flex>
                <datetime v-if="!editing" input-id="startDate" v-model="eventStartDate" type="datetime"
                  input-class="dateTimeInput" :minute-step="15" :week-start="7" use12-hour auto>
                  <label for="startDate" slot="before">Start Date</label>
                </datetime>
                <datetime v-else input-id="startDate" v-model="specificEvent.startDate" type="datetime"
                  input-class="dateTimeInput" :minute-step="15" :week-start="7" use12-hour auto>
                  <label for="startDate" slot="before">Start Date</label>
                </datetime>
              </v-flex>
              <br>
              <v-flex>
                <datetime v-if="!editing" input-id="endDate" v-model="eventEndDate" type="datetime"
                  input-class="dateTimeInput" :minute-step="15" :week-start="7" use12-hour auto>
                  <label for="endDate" slot="before">End Date</label>
                </datetime>
                <datetime v-else input-id="endDate" v-model="specificEvent.endDate" type="datetime"
                  input-class="dateTimeInput" :minute-step="15" :week-start="7" use12-hour auto>
                  <label for="endDate" slot="before">End Date</label>
                </datetime>
              </v-flex>
              <v-flex>
                <v-btn v-if="!editing" raised color="primary" @click="onPickFile">Upload Image</v-btn>
                <v-btn v-else raised color="primary" @click="onPickFile">Change Image</v-btn>
                <input type="file" style="display:none;" ref="fileInput" accept="image/*" @change="onFilePicked">
              </v-flex>
              <v-flex>
                <img v-if="!editing" :src="imageUrl" height="150">
                <img v-else :src="specificEvent.imageUrl" height="150">
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat v-on:click="closeEventDialog">Close</v-btn>
          <v-btn color="success" v-on:click="saveEvent" :disabled="!isComplete">Save</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="error" v-if="editing" v-on:click="deleteEvent">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from "vuex";
  import Event from "../../../store/models/Event.js";
  import {
    CalendarView,
    CalendarViewHeader,
    CalendarMathMixin
  } from "vue-simple-calendar";
  require("vue-simple-calendar/static/css/default.css");

  export default {
    components: {
      CalendarView,
      CalendarViewHeader
    },
    mixins: [CalendarMathMixin],
    data() {
      return {
        eventDialog: false,
        editing: false,
        eventId: "",
        eventTitle: "",
        eventDescription: "",
        eventStartDate: "",
        eventEndDate: "",
        image: null,
        imageUrl: "",
        showDate: this.thisMonth(1),
        showEventTimes: true,
        useDefaultTheme: true,
        useHolidayTheme: true
      };
    },
    computed: {
      ...mapGetters({
        loading: "getLoading",
        events: "getEvents",
        specificEvent: "getEvent"
      }),
      isComplete() {
        if (!this.editing) {
          return (
            this.eventTitle &&
            this.eventDescription &&
            this.eventStartDate &&
            this.eventEndDate &&
            this.imageUrl
          );
        } else {
          return (
            this.specificEvent.title &&
            this.specificEvent.description &&
            this.specificEvent.startDate &&
            this.specificEvent.endDate &&
            this.specificEvent.imageUrl
          );
        }
      },
      themeClasses() {
        return {
          "theme-default": this.useDefaultTheme,
          "holiday-us-traditional": this.useHolidayTheme,
          "holiday-us-official": this.useHolidayTheme
        };
      }
    },
    methods: {
      onPickFile() {
        this.$refs.fileInput.click();
      },
      onFilePicked(event) {
        const files = event.target.files;
        let fileName = files[0].name;
        if (fileName.lastIndexOf(".") <= 0) {
          return alert("Please add a valid file!");
        }
        const fileReader = new FileReader();
        fileReader.addEventListener("load", () => {
          if (this.editing) {
            this.specificEvent.imageUrl = fileReader.result;
          } else {
            this.imageUrl = fileReader.result;
          }
        });
        fileReader.readAsDataURL(files[0]);
        if (this.editing) {
          this.specificEvent.image = files[0];
        } else {
          this.image = files[0];
        }
      },
      thisMonth(d, h, m) {
        const t = new Date();
        return new Date(t.getFullYear(), t.getMonth(), d, h || 0, m || 0);
      },
      onClickDay(day) {
        console.log(day);
      },
      onClickEvent(e) {
        console.log("You clicked: " + e.title + ": " + e.id);
        this.$store.dispatch("getSpecificEvent", e.id);
        this.editing = true;
        this.eventDialog = true;
      },
      setShowDate(d) {
        this.showDate = d;
      },
      saveEvent() {
        if (!this.editing) {
          let e = new Event(
            0,
            new Date(this.eventStartDate).toISOString(),
            new Date(this.eventEndDate).toISOString(),
            this.eventTitle,
            this.eventDescription,
            this.image,
            this.imageUrl,
            "",
            new Date().toISOString()
          );

          this.$store.dispatch("createEvent", e);
        } else {
          this.$store.dispatch("editEvent", this.specificEvent);
        }

        this.closeEventDialog();
      },
      deleteEvent() {
        this.$confirm("Do you really want to delete this event?").then(res => {
          if (res) {
            this.$store.dispatch("deleteEvent", this.specificEvent.id);
          }
        });

        this.closeEventDialog();
      },
      closeEventDialog() {
        this.eventTitle = "";
        this.eventDescription = "";
        this.eventStartDate = "";
        this.eventEndDate = "";
        this.eventDialog = false;
        this.editing = false;
      }
    },
    created: function () {
      this.$store.dispatch("getAllEvents");
    }
  };
</script>

<style>
  .calendar-container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  /* For long calendars, ensure each week gets sufficient height. The body of the calendar will scroll if needed */
  .cv-wrapper.period-month.periodCount-2 .cv-week,
  .cv-wrapper.period-month.periodCount-3 .cv-week,
  .cv-wrapper.period-year .cv-week {
    min-height: 6rem !important;
  }

  .cv-week {
    min-height: 6em !important;
  }
</style>